// extracted by mini-css-extract-plugin
module.exports = {"winnerPending":"_1GPo_aetCYW4FIvczB_vBh"};